import { BrowserRouter } from 'react-router-dom';
import { Login, MenuLateral } from './shared/components';
import { AppRoutes } from './routes';
import { AppThemeProvider, DrawerProvider, AuthProvider } from './shared/contexts';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/pt-br';

import { Chart as ChartJS, Title, Tooltip, LineElement, Legend, CategoryScale, LinearScale, PointElement, Filler, SubTitle } from 'chart.js';

ChartJS.register(
  Title, Tooltip, LineElement, Legend,
  CategoryScale, LinearScale, PointElement, Filler, SubTitle
)

function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='pt-br'>

      <AuthProvider>
        <AppThemeProvider>

          <Login>

            <DrawerProvider>
              <BrowserRouter basename={process.env.NODE_ENV === 'production' ? '' : ''}>
                <MenuLateral>
                  <AppRoutes />
                </MenuLateral>

              </BrowserRouter>
            </DrawerProvider>

          </Login>

        </AppThemeProvider>
      </AuthProvider>

    </LocalizationProvider>
  );
}

export default App;
